import { __assign } from "tslib";
import { compose } from "redux";
var DEV_TOOLS_COMPOSE = "__REDUX_DEVTOOLS_EXTENSION_COMPOSE__";
var devModeConfig;
var defaultTyduxDevModeConfig = {
    autoUseDevToolsInDevelopmentMode: true
};
export function enableTyduxDevelopmentMode(enableOrConfig) {
    if (enableOrConfig === void 0) { enableOrConfig = true; }
    if (devModeConfig === undefined && enableOrConfig && (typeof Window === "function")) {
        console.log("enableTyduxDevelopmentMode() called. Tydux is running in the development mode.");
    }
    if (enableOrConfig === true) {
        devModeConfig = defaultTyduxDevModeConfig;
    }
    else if (enableOrConfig === false) {
        devModeConfig = undefined;
    }
    else {
        devModeConfig = __assign(__assign({}, defaultTyduxDevModeConfig), enableOrConfig);
    }
}
export function isTyduxDevelopmentModeEnabled() {
    return devModeConfig !== undefined;
}
export function checkDevModeAndCreateDevToolsEnabledComposeFn(options) {
    if (options === void 0) { options = {}; }
    if (isTyduxDevelopmentModeEnabled()
        && devModeConfig.autoUseDevToolsInDevelopmentMode
        && window.hasOwnProperty(DEV_TOOLS_COMPOSE)) {
        var defaultOptions = devModeConfig !== undefined
            && devModeConfig.devToolsOptions !== undefined
            ? devModeConfig.devToolsOptions
            : {};
        options = __assign(__assign({}, defaultOptions), options);
        return window[DEV_TOOLS_COMPOSE](options);
    }
    return compose;
}
